import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import CityCoverageManager from '../components/CityCoverageManager';
import { ArrowLeft, MapPin } from 'lucide-react';

const AdminCityCoveragePage: React.FC = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  React.useEffect(() => {
    // Check if user is admin
    if (user?.role !== 'admin') {
      navigate('/');
      return;
    }
  }, [user?.role, navigate]);

  if (user?.role !== 'admin') {
    return null;
  }

  return (
    <div className="container mx-auto px-4 py-8 max-w-6xl">
      <div className="bg-white rounded-lg shadow-md p-6 mb-6">
        {/* Header */}
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center">
            <button
              onClick={() => navigate('/admin')}
              className="mr-4 p-2 hover:bg-gray-100 rounded-md transition-colors"
              aria-label="Back to dashboard"
            >
              <ArrowLeft className="h-5 w-5 text-gray-600" />
            </button>
            <MapPin className="h-8 w-8 text-black mr-3" />
            <h1 className="text-3xl font-bold text-black">City & Coverage Management</h1>
          </div>
        </div>

        <p className="text-gray-600 mb-6">
          Configure the cities where your service is available and define their geographical coverage areas. 
          View the combined coverage map to see all service areas at once.
        </p>

        {/* City Coverage Manager Component */}
        <CityCoverageManager />
      </div>
    </div>
  );
};

export default AdminCityCoveragePage;

